import React from "react";

// Any request to these host names will be replaced by a plain 404 page,
// so the site content is never served under a domain we no longer own/support.
const BLOCKED_HOSTS = new Set([
  "gcprimo.com",
  "www.gcprimo.com",
  "gcboss.com",
  "www.gcboss.com",
]);

export default function DomainGuard({ children }) {
  const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  // Test-only override: ?force404=1 will render the 404 page (useful for QA on preview)
  const forceTest =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("force404") === "1";

  if (BLOCKED_HOSTS.has(host) || forceTest) {
    // Set a proper 404-ish document title and prevent indexing
    if (typeof document !== "undefined") {
      document.title = "404 — Not Found";
      let robots = document.querySelector('meta[name="robots"]');
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    }

    return (
      <div
        data-testid="domain-blocked-404"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
          background: "#ffffff",
          color: "#111",
          padding: "24px",
          textAlign: "left",
        }}
      >
        <div style={{ maxWidth: 640 }}>
          <h1 style={{ fontSize: 32, fontWeight: 700, margin: "0 0 12px" }}>404 — Not Found</h1>
          <p style={{ fontSize: 15, color: "#555", margin: 0 }}>
            The requested URL was not found on this server.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
